// Modules:
import React from 'react';

// Router:
import { NavLink } from 'react-router-dom/';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';

// Components:
import TopicsDrawer from './TopicsDrawer';

const styles = {
    '&.MuiAccordion-root': {
        backgroundColor: 'black',
        color: 'white',
    },
    '&.MuiAccordionSummary-root': {
        width: '100%',
        paddingLeft: '0.6rem',
        paddingRight: '0.6rem',
    },
};

const Navbar = ({ routerParams, handleErrorReset }) => (
    // // Render // //
    <div className="navbar">
        <Accordion sx={styles} expanded={false}>
            <AccordionSummary
                sx={styles}
                expandIcon={
                    routerParams.topic ? (
                        <TopicsDrawer routerParams={routerParams} />
                    ) : null
                }
                aria-controls="panel1a-content"
                id="navbar-header"
            >
                <div className="mdh-header">
                    <button
                        type="button"
                        className="navbar-button"
                        onClick={handleErrorReset}
                    >
                        <NavLink
                            to="/"
                            activeStyle={{ textDecoration: 'none' }}
                        >
                            <img
                                className="md-logo"
                                src="/ephtportal/images/release_header.png"
                                alt="maryland-flag-logo"
                            />
                        </NavLink>
                        <NavLink
                            to="/"
                            activeStyle={{ textDecoration: 'none' }}
                        >
                            <div className="app-title-container">
                                <p className="app-title">
                                    Maryland Department of Health
                                </p>
                                <p className="app-title byline">
                                    Environmental Public Health Tracking
                                </p>
                            </div>
                        </NavLink>
                    </button>
                </div>
            </AccordionSummary>
        </Accordion>
    </div>
);
export default Navbar;
